import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';

export default {
  getTrackingUpdateStatus({ commit }, params = {}) {
    const { filters = {} } = params;
    const { delivery_method_ids, logistic_provider_ids, shipping_date, changeType } = filters;
    const {
      start,
      end,
    } = shipping_date;

    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query (
        $delivery_method_ids: [String]
        $logistic_provider_ids: [Int]
        $dispatched_from: Date!
        $dispatched_to: Date!
        $changeType: String
      ) {
          trackingUpdateStatus(
            delivery_method_ids: $delivery_method_ids
            logistic_provider_ids: $logistic_provider_ids
            dispatched_from: $dispatched_from
            dispatched_to: $dispatched_to
            changeType: $changeType
          ) {
            columns {
              name
              label
              total
              percentage
              isFixed
            }
            rows{
              delivery
              dispatched
              percentage
              periods{
                name
                value
              }
              without_carrier_update
            }
          }
        }`,
      {
        delivery_method_ids,
        logistic_provider_ids,
        dispatched_from: start,
        dispatched_to: end,
        changeType,
      })
      .then((res) => {
        const { data = {} } = res || {};
        const { trackingUpdateStatus = {} } = data || {};

        commit('toggleLoading', false);
        return Promise.resolve({
          ...trackingUpdateStatus,
          rows: trackingUpdateStatus.rows.map(row => ({
            ...row,
            children: [],
          })),
        });
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getTrackingUpdateStatusDetail({ commit }, params = {}) {
    commit('toggleLoading', true);
    const {
      row, delivery_method_ids = [],
      logistic_provider_ids,
      shipping_date,
      changeType,
    } = params;
    const { delivery } = row;
    const {
      start,
      end,
    } = shipping_date;

    return GraphQlClient.mutation(`
    mutation(
      $delivery: Date!
      $delivery_method_ids: [Int]
      $logistic_provider_ids: [Int]
      $start: Date!
      $end: Date!
      $changeType: String
    ) {
        trackingUpdateStatusDetail(
          delivery: $delivery
          delivery_method_ids: $delivery_method_ids
          logistic_provider_ids: $logistic_provider_ids
          start: $start
          end: $end
          changeType: $changeType
        ) {
          rows{
            dispatched
            without_carrier_update
            periods{
              name
              value
            }
            logistic_provider{
              id
              name
              delivery_method{
                type
              }
            }
            delivery_method_name
            delivery_method_id
          }
        }
      }`, {
        delivery,
        logistic_provider_ids,
        delivery_method_ids,
        start,
        end,
        changeType,
      })
      .then((res) => {
        const { data = {} } = res || {};
        const { trackingUpdateStatusDetail = {} } = data || {};
        const { rows = [] } = trackingUpdateStatusDetail || {};

        commit('toggleLoading', false);
        return Promise.resolve(rows);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  exportDetail({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation (
        $shipper_id: Int
        $delivery_method_id: Int
        $logistic_provider_id: Int
        $header_field: String
        $delivery_date: String
        $dispatched_from: String
        $dispatched_to: String
        $changeType: String
      ) {
        exportDetail (
          shipper_id: $shipper_id
          delivery_method_id: $delivery_method_id
          logistic_provider_id: $logistic_provider_id
          header_field: $header_field
          delivery_date: $delivery_date
          dispatched_from: $dispatched_from
          dispatched_to: $dispatched_to
          changeType: $changeType
        ) {
          file
          headers
        }
      }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { exportDetail = {} } = data || {};
        const { file = {}, headers = {} } = exportDetail || {};

        commit('toggleLoading', false);

        const b64DecodeUnicode = str =>
           decodeURIComponent(window.atob(str).split('').map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

        const decodeFile = b64DecodeUnicode(file);

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob(['\ufeff', decodeFile],
          { type: 'text/csv;charset=iso-8859-1;' }));
        link.download = `${headers.split('.').slice(0, -1).join('.')}.csv`;
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/tracking-update-status-details/store/actions.js